// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Home_wrapper__3lv0b","card":"Home_card__1C8Jg","info":"Home_info__WifeD","btn":"Home_btn__3SKtF"};